module.exports = __webpack_public_path__ + "./images/963de9c203fff05ca304295e4d0e31db.webp";